import { render } from "./ProfileEmailTab.vue?vue&type=template&id=021e4802&scoped=true&ts=true"
import script from "./ProfileEmailTab.vue?vue&type=script&lang=ts"
export * from "./ProfileEmailTab.vue?vue&type=script&lang=ts"

import "./ProfileEmailTab.vue?vue&type=style&index=0&id=021e4802&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021e4802"]])

export default __exports__